export default function EFLaptop(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M25.5 6H6.5C5.67157 6 5 6.67157 5 7.5V21H27V7.5C27 6.67157 26.3284 6 25.5 6Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.7845 26H5.21555C4.15435 26 3.42872 24.9282 3.82283 23.9429L5 21H27L28.1772 23.9429C28.5713 24.9282 27.8456 26 26.7845 26Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M15 8H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
